import axiosInstance from '../helpers/axios.helper';

export const userService = {
  login,
  logout
};

function login(email, password) {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-Key-Inflection': 'camel'
    },
    data: { email, password },
    url: '/api/v1/auth/sign_in'
  };

  return axiosInstance(requestOptions)
    .then(handleResponse)
    .then(user => {
      // login successful if there's a jwt token in the response
      if (user) {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        localStorage.setItem('user', JSON.stringify(user));
      }

      return user;
    });
}

function logout() {
  // remove user from local storage to log user out
  localStorage.removeItem('user');
}

function handleResponse(response) {
  if (!response.statusText === 'OK') {
    if (response.status === 401) {
      // auto logout if 401 response returned from api
      logout();
      location.reload(true);
    }

    const error = (response.data && response.data.message) || response.statusText;
    return Promise.reject(error);
  }

  return Promise.resolve(response.data);
};



// WEBPACK FOOTER //
// ./src/services/user.service.js